import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, viewChild } from '@angular/core';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { UntilDestroy } from '@ngneat/until-destroy';
import { buildUrl } from '@trimble-gcs/common';
import { ModusTooltipModule } from '@trimble-gcs/modus';
import { FileSizePipe } from '@trimble-gcs/ngx-common';
import { ProjectUsage } from '../../../quota/project-quota.models';
import { projectUsageTableTranslations } from './project-usage-table.translations';

interface ProjectUsageView extends ProjectUsage {
  projectUrl: string;
}

@UntilDestroy()
@Component({
  selector: 'sd-project-usage-table',
  imports: [CommonModule, ModusTooltipModule, MatTableModule, MatSortModule, FileSizePipe],
  templateUrl: './project-usage-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectUsageTableComponent {
  private readonly sort = viewChild.required(MatSort);

  readonly projectUsages = input.required<ProjectUsage[]>();
  readonly connectUrl = input.required<string>();

  readonly dataSource = computed(() => this.getDataSource());
  readonly displayedColumns = ['projectId', 'projectName', 'usage'];

  readonly translations = projectUsageTableTranslations();

  private getDataSource(): MatTableDataSource<ProjectUsageView> {
    const projectUsages: ProjectUsageView[] = this.projectUsages().map((usage) => {
      return {
        ...usage,
        projectUrl: buildUrl(this.connectUrl(), `/projects/${usage.projectId}/settings/details`),
      };
    });

    const dataSource = new MatTableDataSource<ProjectUsageView>(projectUsages);
    dataSource.sort = this.sort();
    return dataSource;
  }
}
